import { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { User as FirebaseUser } from 'firebase/auth'
import { initialUserState, selectUser, updateUserAction } from '../User'
import {
  fetchMailProfile,
  updateUser,
  once,
  firestoreSubscriptionData,
  getFirestoreStripeConfig,
  retrieveStripePrice,
  sendError
} from '@batical/common'
import { loadSubscription } from '../subscription/SubscriptionAction'
import { getUnixTime } from 'date-fns'
import { definseStripePrice, definseStripePriceId } from '../Stripe/StripeAction'

import { saveUserProfile } from '../MailProfile/MailProfileAction'

// eslint-disable-next-line import/prefer-default-export
export function useSyncUser() {
  const userState = useSelector(selectUser)
  const user = useMemo(() => userState, [userState])

  const dispatch = useDispatch()
  const sync = useCallback(
    async (firebaseUser: FirebaseUser | null) => {
      try {
        if (firebaseUser && firebaseUser.uid) {
          const data = await once(`users/${firebaseUser.uid}/profile`)

          const databaseUser = data.val()
          if (databaseUser == null) {
            //create account
            const newUser = { ...initialUserState }
            newUser.email = firebaseUser.email
            newUser.id = firebaseUser.uid
            newUser.displayname = firebaseUser.displayName
            newUser.createdAt = getUnixTime(new Date())

            await updateUser(firebaseUser.uid, newUser)

            dispatch(updateUserAction(newUser))
          } else {
            // if (user.lastModified! < databaseUser.lastModified) {
            dispatch(updateUserAction(databaseUser))
            //}
          }
          // check subscription

          const sub = await firestoreSubscriptionData(firebaseUser.uid)
          if (sub) {
            dispatch(loadSubscription(sub))
          }

          const response = await getFirestoreStripeConfig(firebaseUser.uid)

          const priceId = response && typeof response === 'object' && 'priceId' in response ? response.priceId : undefined
          const priceIds = priceId != null ? (Array.isArray(priceId) ? priceId : [priceId]) : []

          if (priceIds.length > 0) {
            dispatch(definseStripePriceId(priceIds))
            retrieveStripePrice(priceIds)
              .then(prd => {
                dispatch(definseStripePrice(prd))
              })
              .catch(error => sendError(error))
          }

          //update mail profile/fetch
          const mailProfile = await fetchMailProfile(firebaseUser.uid)

          if (mailProfile) {
            dispatch(saveUserProfile(mailProfile))
          }
        }
      } catch (error) {
        sendError(error, 'syncUser')
        return Promise.reject(error)
      }
      return
    },
    [dispatch]
  )

  return { user, sync }
}
